import { CatalogTranslate } from './catalogTranslate.model';

const catalogTranslatePTBR: CatalogTranslate = {
  page: {
    title: 'Catálogo',
    tabs: {
      services: 'Serviços',
      packages: 'Pacotes',
    },
    search: {
      services: 'Busque por serviço',
      packages: 'Busque por pacote',
    },
    emptyState: {
      services: 'Nenhum serviço cadastrado',
      servicesHint: 'Crie um novo serviço para começar',
      packages: 'Nenhum pacote cadastrado',
      packagesHint: 'Crie um novo pacote para começar',
    },
  },
  archivedModal: {
    title: 'Itens arquivados',
    openButton: 'Arquivados',
    tabs: {
      services: 'Serviços',
      packages: 'Pacotes',
    },
    empty: 'Nenhum item arquivado.',
    archivedAt: 'Arquivado em',
    restoreButton: 'Restaurar',
  },
  list: {
    archived: 'Arquivado',
    serviceCount: '{{count}} serviços',
    serviceCountSingular: '{{count}} serviço',
    actions: {
      detail: 'Detalhe',
      edit: 'Editar',
      archive: 'Arquivar',
      restore: 'Restaurar',
    },
  },
  detail: {
    price: 'Preço',
    description: 'Descrição',
    createdAt: 'Criado em',
    archivedAt: 'Arquivado em',
    includedServices: 'Serviços incluídos',
    servicePrice: 'Preço do serviço: {{price}}',
    actions: {
      edit: 'Editar',
      archive: 'Arquivar',
      restore: 'Restaurar',
      close: 'Fechar detalhe',
    },
  },
  form: {
    title: {
      createService: 'Novo serviço',
      editService: 'Editar serviço',
      createPackage: 'Novo pacote',
      editPackage: 'Editar pacote',
    },
    fields: {
      name: {
        placeholderService: 'Nome do serviço',
        placeholderPackage: 'Nome do pacote',
      },
      description: {
        placeholder: 'Descrição',
      },
      price: {
        placeholder: 'Preço (R$)',
        frozenHint:
          'Mudar o preço aqui não altera vendas já registradas — cada venda guarda o valor combinado na época.',
      },
      imageService: 'Imagem do serviço',
      imagePackage: 'Imagem do pacote',
      services: {
        placeholder: 'Selecione os serviços',
        searchPlaceholder: 'Buscar serviço',
        noResults: 'Nenhum serviço encontrado',
      },
    },
    errors: {
      nameRequired: 'Nome é obrigatório',
      nameMax: 'Nome deve ter no máximo 100 caracteres',
      descriptionMax: 'Descrição deve ter no máximo 500 caracteres',
      pricePositive: 'Preço deve ser maior que zero',
      servicesMin: 'Selecione ao menos um serviço',
    },
    actions: {
      clear: 'Limpar',
      save: 'Salvar',
      saveError: 'Erro ao salvar. Tente novamente.',
    },
  },
  imageUpload: {
    placeholder: 'Arraste uma imagem aqui ou clique para selecionar',
    hint: 'JPG, PNG ou WebP • máx 5 MB',
    dragRejected: 'Tipo não permitido',
    dropToReplace: 'Solte para substituir a imagem',
    cancelLabel: 'Cancelar upload',
    previewAlt: 'Pré-visualização da imagem',
    errors: {
      invalidType: 'Tipo de arquivo não permitido',
      tooLarge: 'Arquivo muito grande (máximo {{size}} MB)',
      uploadFailed: 'Falha no upload. Tente novamente.',
      invalidContent:
        'Arquivo inválido: o conteúdo não corresponde a uma imagem real',
    },
  },
  conflictModal: {
    title: 'Não é possível arquivar',
    description: 'O serviço {{name}} está em uso nos seguintes pacotes:',
    question: 'Deseja desassociar de todos os pacotes e arquivar mesmo assim?',
    actions: {
      cancel: 'Cancelar',
      confirm: 'Desassociar e arquivar',
    },
  },
  toasts: {
    serviceCreated: 'Serviço criado com sucesso',
    serviceCreateError: 'Erro ao criar serviço. Tente novamente.',
    serviceUpdated: 'Serviço atualizado',
    serviceUpdateError: 'Erro ao atualizar serviço. Tente novamente.',
    serviceDeleted: 'Serviço arquivado',
    serviceDeleteError: 'Erro ao arquivar serviço. Tente novamente.',
    serviceRestored: 'Serviço restaurado',
    serviceRestoreError: 'Erro ao restaurar serviço. Tente novamente.',
    serviceDetached: 'Serviço desassociado dos pacotes',
    serviceDetachError: 'Erro ao desassociar serviço. Tente novamente.',
    packageCreated: 'Pacote criado com sucesso',
    packageCreateError: 'Erro ao criar pacote. Tente novamente.',
    packageUpdated: 'Pacote atualizado',
    packageUpdateError: 'Erro ao atualizar pacote. Tente novamente.',
    packageDeleted: 'Pacote arquivado',
    packageDeleteError: 'Erro ao arquivar pacote. Tente novamente.',
    packageRestored: 'Pacote restaurado',
    packageRestoreError: 'Erro ao restaurar pacote. Tente novamente.',
    saleRegistered: 'Venda registrada',
    saleRegisterError: 'Erro ao registrar venda. Tente novamente.',
    saleCancelled: 'Venda cancelada',
    saleCancelError: 'Erro ao cancelar venda. Tente novamente.',
    installmentPaidError: 'Erro ao marcar parcela como paga. Tente novamente.',
  },
};

export default catalogTranslatePTBR;
